import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '@library/components/card/Card';
import type {
  ModifiedPlayer,
  NFLTeamInputs,
  OddsResponse
} from '@library/types/simulations';
import type { LeagueTeamPlayer } from '@library/types/player';
import type { OverrideValidationError } from '@bo-hooks/simulations/useSimulationDetailSteps';
import { RemovedPlayers } from '@bo-components/simulations/steps/StepOneBuild/RemovedPlayers';
import { TeamInputs } from '@bo-components/simulations/steps/StepOneBuild/TeamInputs/TeamInputs';
import { TeamPlayers } from '@bo-components/simulations/steps/StepOneBuild/TeamPlayers';
import type { Updater } from 'use-immer';

// Skeleton card. Values will be controlled from the parent component
export const TeamDisplay = ({
  defaultPlayers,
  homeTeam,
  leagueId,
  modifiedPlayers,
  simulationId = '',
  simulationOdds,
  onSetTeamInputs,
  overrideValidationErrors,
  setModifiedPlayers,
  setRemovedPlayers,
  setOverrideValidationErrors,
  removedPlayers,
  teamId,
  teamInputs,
  teamName,
  teamPlayers
}: {
  defaultPlayers: Array<ModifiedPlayer>;
  homeTeam: boolean;
  leagueId: string;
  modifiedPlayers: Array<ModifiedPlayer>;
  simulationId?: string;
  simulationOdds: OddsResponse | undefined;
  onSetTeamInputs: (
    key: keyof NFLTeamInputs,
    value: number | string | boolean
  ) => void;
  overrideValidationErrors: Array<OverrideValidationError>;
  setModifiedPlayers: Updater<Array<ModifiedPlayer>>;
  setOverrideValidationErrors: Updater<Array<OverrideValidationError>>;
  setRemovedPlayers: Updater<Array<Omit<ModifiedPlayer, 'playerOverrides'>>>;
  removedPlayers: Array<Omit<ModifiedPlayer, 'playerOverrides'>>;
  teamId: string;
  teamInputs: NFLTeamInputs;
  teamName: string;
  teamPlayers: Array<LeagueTeamPlayer>;
}) => {
  return (
    <Card className="text-soClean-100">
      <CardHeader>
        <CardTitle>
          {teamName} (ID: {teamId})
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col justify-center gap-4">
        <TeamInputs teamInputs={teamInputs} onSetTeamInputs={onSetTeamInputs} />
        <TeamPlayers
          defaultPlayers={defaultPlayers}
          homeTeam={homeTeam}
          leagueId={leagueId}
          modifiedPlayers={modifiedPlayers}
          overrideValidationErrors={overrideValidationErrors}
          setModifiedPlayers={setModifiedPlayers}
          setOverrideValidationErrors={setOverrideValidationErrors}
          simulationId={simulationId}
          simulationOdds={simulationOdds}
          removedPlayers={removedPlayers}
          teamName={teamName}
          teamPlayers={teamPlayers}
        />
        <RemovedPlayers
          homeTeam={homeTeam}
          removedPlayers={removedPlayers}
          setRemovedPlayers={setRemovedPlayers}
          teamPlayers={teamPlayers}
        />
      </CardContent>
    </Card>
  );
};
